module.exports = __webpack_public_path__ + "static/affiliate/affiliate-insurance-48b2200dd9711599020a3a9b6728eb47.webp";